"use strict";import{AccordionItem as e}from"./src/AccordionItem.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-accordion-item",e);
//# sourceMappingURL=sp-accordion-item.js.map
